import { Injectable } from '@angular/core';
import { IStripeCustomerClient } from '@core/models/admin-manager/companies.model';
import { IAccountInfo } from '@core/models/admin/account/accountInfo.model';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';
import { Observable } from 'rxjs';
import {
  ICompanyBillinginfomormationModel,
  ICompanyModel,
  ICompanyOnBoardImageModel,
  ICompanyOnBoardModel,
  ICompanyRequestModel,
  IImageCompanyModel,
} from 'src/app/core/models/admin/company/company.model';
import { HttpClientRequestService } from '../../../request-services/httpclient.request.services';
import { Store } from '@ngrx/store';
import { selectCompanyByGuid } from 'src/app/store/company-info/company-info.selectors';
import { filter, map, take } from 'rxjs/operators';
import { loadCompany } from 'src/app/store/company-info/company-info.actions';

@Injectable({
  providedIn: 'root',
})
export class CompanyRepositoryService {
  constructor(
    private repo: HttpClientRequestService,
    private readonly store: Store<Store>,
  ) {}

  companyinfo(request: ICompanyModel): Observable<any> {
    this.store.dispatch(loadCompany({ payload: request }));
    // Return the observable that selects the company by its GUID
    return this.store.select(selectCompanyByGuid(request.CompanyGuid)).pipe(
      filter((response) => Boolean(response)),
      take(1),
      map((company) => JSON.parse(JSON.stringify(company))),
    );
  }

  saveCompanyInfo(request: ICompanyModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiCreatecompany;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  saveImageCompany(request: IImageCompanyModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdateimagecompany;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  ValidateCompanyStorage(request: ICompanyOnBoardModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiOnboardvalidatestorage;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  CreateCompanyStorage(request: ICompanyOnBoardModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiOnboard;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  UpdateImageCompanyStorage(request: ICompanyOnBoardImageModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiOnboardlogo;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  UpdateCompanyNameB2CUser(request: IAccountInfo): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdatecompanynameb2cuser;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  CreateCompanyCustomerStripe(request: IStripeCustomerClient): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiCreateStripeCustomerClient;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  UpdateStripeCompany(request: ICompanyModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdatestripecompany;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  CreateBillingInformation(request: ICompanyBillinginfomormationModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiCompanyBillingInformation;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  GetBillingInformation(request: ICompanyRequestModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiCompanyGetBillingInformation;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }
}
